if (!customElements.get('kroslo-chef-videos')) {
  class KrosloChefVideos extends HTMLElement {
    constructor() {
      super();
      this.containers = Array.from(this.querySelectorAll('[data-video-container]'));

      this.addEventListener('click', (e) => {
        const playBtn = e.target.closest('[data-play-button]');
        if (playBtn) {
          e.preventDefault();
          const container = playBtn.closest('[data-video-container]');
          if (container) this._play(container);
          return;
        }

        // Clicking the poster also plays
        const poster = e.target.closest('[data-video-poster]');
        if (poster) {
          const container = poster.closest('[data-video-container]');
          if (container) this._play(container);
        }
      });
    }

    /**
     * Hide the poster AND the play button for a container.
     * Show them again when provided with null (restore all).
     */
    _setPlayingState(container, isPlaying) {
      const poster = container.querySelector('[data-video-poster]');
      const btn = container.querySelector('[data-play-button]');

      if (isPlaying) {
        if (poster) poster.classList.add('is-hidden');
        if (btn) btn.classList.add('is-hidden');
      } else {
        if (poster) poster.classList.remove('is-hidden');
        if (btn) btn.classList.remove('is-hidden');
      }
    }

    _play(targetContainer) {
      // 1. Pause all videos and restore all posters + play buttons
      this.containers.forEach((c) => {
        const vid = c.querySelector('[data-video-element]');
        if (vid) {
          vid.pause();
          vid.removeAttribute('controls');
        }
        this._setPlayingState(c, false);
      });

      // 2. Play the target video
      const targetVideo = targetContainer.querySelector('[data-video-element]');
      if (!targetVideo) return;

      this._setPlayingState(targetContainer, true);
      targetVideo.setAttribute('controls', 'controls');

      targetVideo.play().catch(() => {
        // Autoplay blocked — restore UI
        this._setPlayingState(targetContainer, false);
        targetVideo.removeAttribute('controls');
      });

      // 3. Restore UI when the video ends
      targetVideo.onended = () => {
        this._setPlayingState(targetContainer, false);
        targetVideo.removeAttribute('controls');
        targetVideo.currentTime = 0;
      };
    }
  }

  customElements.define('kroslo-chef-videos', KrosloChefVideos);
}
